import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    indeterminate: false
  },
  mutations: { // syncronous
    indeterminate(state, payload) {
      state.indeterminate = payload;
    }
    //
  },
  actions: { // asyncronous.
    indeterminate(state, payload) {
      state.commit('indeterminate', payload);
    }
  },
  getters: {
    indeterminate(state) {
      return state.indeterminate;
    }
  }

})
